import { replaceNewLineWithBr } from "utilities/reactUtils";

interface Props {
  value: string
}

const ReadonlyMultilineText = (props: Props) => {
  return replaceNewLineWithBr(props.value);
};

export default ReadonlyMultilineText;